'use client';

import React from 'react';
import { useRouter } from 'next/navigation';

/**
 * Serial-number lookup form for the /verify landing page. Navigates to
 * /verify/[serial] which performs the actual registry lookup (ISR, public).
 * Kept as a small client island so the landing page stays a server component.
 */
export default function VerifyLookupForm() {
  const router = useRouter();
  const [serial, setSerial] = React.useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const cleaned = serial.trim().toUpperCase();
    if (cleaned) router.push(`/verify/${encodeURIComponent(cleaned)}`);
  };

  return (
    <form onSubmit={submit} style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
      <label htmlFor="verify-serial" style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' }}>
        Credit serial number
      </label>
      <input
        id="verify-serial"
        className="input"
        type="text"
        value={serial}
        onChange={(e) => setSerial(e.target.value)}
        placeholder="MCC-CC-F01-MEX0021-2026-00000001-3"
        autoComplete="off"
        spellCheck={false}
        style={{ flex: '1 1 280px', minWidth: 0, width: 'auto', minHeight: 44, background: '#ffffff', fontFamily: 'var(--font-mono)', letterSpacing: '0.03em' }}
      />
      <button type="submit" className="btn btn-primary" disabled={!serial.trim()}>
        Verify credit <span className="btn-arrow" aria-hidden="true">→</span>
      </button>
    </form>
  );
}
